import { ArrowRightIcon } from "@heroicons/react/solid";
import React from "react";
const emailAddress = "yashkothekar1900@gmail.com";
const subject="AA";
export default function Navbar() {
  return (
    <header className="bg-gray-800 md:sticky top-0 z-10">
      <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
        <a className="title-font font-medium text-white mb-4 md:mb-0">
          <a href="#about" className="ml-3 text-xl">
            Yash Kothekar
          </a>
        </a>
        <nav className="md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-700	flex flex-wrap items-center text-base justify-center">
          <a href="#projects" className="mr-5 hover:text-white">
            Past Work
          </a>
          <a href="#skills" className="mr-5 hover:text-white">
            Skills
          </a>
          <a href="https://reliable-marzipan-03ddf0.netlify.app/" className="mr-5 hover:text-white">
            Blog
          </a>
          <a href="https://github.com/yashk1900">
            <img src="./github-icon-copy.png" style={{ maxHeight: '65px' , padding: '10px'}} ></img>
          </a>
          <a href="https://www.linkedin.com/in/yashk1900/">
            <img src="./linkedinlogo.png" style={{ maxHeight: '65px', padding: '10px' }} ></img>
          </a>
          <a href={`mailto:${emailAddress}?subject=${encodeURIComponent(subject)}`}>
            <img src="./mail.png" style={{ maxHeight: '65px', padding: '10px' }} ></img>
          </a>
          {/* <a href="#testimonials" className="mr-5 hover:text-white">
            Testimonials max-width:
          </a> */}
        </nav>
        <a
          href="#contact"
          className="inline-flex items-center bg-gray-800 border-0 py-1 px-3 focus:outline-none hover:bg-gray-700 rounded text-base mt-4 md:mt-0">
          Hire Me
          <ArrowRightIcon className="w-4 h-4 ml-1" />
        </a>
      </div>
    </header>
  );
}


// WEBPACK FOOTER //
// ./src/components/navbar.js